export const SystemAdjustmentPill: React.FC = () => (
  <span className="tw-whitespace-nowrap tw-inline-flex tw-items-center tw-gap-x-1.5 tw-rounded-md tw-px-2 tw-py-0.5 tw-text-[0.6875rem] tw-font-medium tw-text-iron-300 tw-ring-1 tw-ring-inset tw-ring-iron-700">
    <svg
      className="tw-flex-shrink-0 tw-h-1.5 tw-w-1.5 tw-fill-red"
      viewBox="0 0 6 6"
      aria-hidden="true">
      <circle cx="3" cy="3" r="3" />
    </svg>
    <span>System Adjustment</span>
  </span>
); 